/**
 * @summary - Component that Provides PPM Generation Repository 
 * @autor vengateshwaran k
 * @since 2024-06-21
 */
import { FemsGraph, MasterGraph,BemsGraph } from "../../utility/apiURLS";
import Axios from '../data-access/genericAxios';
import ReArrangeLabel from "../../components/commoncomponents/ReArrangeLabel";
import { getFacilityId, getcompanyId,getAuthToken } from '../../utility/tokenUtility'
const token = getAuthToken('id_token');
async function getPpmGenerationList(value) {
  const response = await Axios.post(`${FemsGraph}/api/GraphPPMGeneration/GetPPMGenerationList`, value);
  return response;
}

async function getPpmGenerationListBEMS(value) {
  const response = await Axios.post(`${BemsGraph}/api/GraphPPMGeneration/GetPPMGenerationList`, value);
  return response;
}
async function getLocationDetails(facilityId) {
  const response = await Axios.get(`${MasterGraph}/api/graph/GetUserLocationDetailsByFacilityId/${facilityId}?page=1&size=2000`);
  if (response?.status !== 'error') {
    const reArrangedData = ReArrangeLabel(response?.data?.items, "locationcode", "label");
    return reArrangedData;
  }
  return response;
}

async function getPPMGenerationFetch(facilityId, workGroupId) { 
  const response = await Axios.get(`${FemsGraph}/api/GraphPPMGeneration/GetPPMGenerationFetch/${facilityId},${workGroupId}?size=1000`);
  return response;
}

async function getBEMSPPMGenerationFetch(facilityId, workGroupId) { 
  const response = await Axios.get(`${BemsGraph}/api/GraphPPMGeneration/GetPPMGenerationFetch/${facilityId},${workGroupId}?size=1000`);
  return response;
}

async function getPPMGenerationFetchBEMS(facilityId, workGroupId) { 
  const response = await Axios.get(`${BemsGraph}/api/GraphPPMGeneration/GetPPMGenerationFetch/${facilityId},${workGroupId}?size=1000`);
  return response;
}
async function getAllAssetsFromAssetRegister(facilityId, workGroupId) {
  const response = await Axios.get(`${FemsGraph}/api/GraphAssetregister/GetAssetListByWorkGroup/${facilityId}/${workGroupId}?size=1000`);
  return response;
}

async function getFemsWorkOrderDetails(facilityId, workOrderId) {
  const response = await Axios.get(`${FemsGraph}/api/GraphWorkorderReport/GetScheduleWorkorderFetchByWorkOrderId/${facilityId},${workOrderId},${token}?size=1000`);
  return response?.data[0];
}

async function getBemsWorkOrderDetails(facilityId, workOrderId) {
  const response = await Axios.get(`${BemsGraph}/api/GraphWorkorderReport/GetScheduleWorkorderFetchByWorkOrderId/${facilityId},${workOrderId},${token}?size=1000`);
  return response;
}
async function regenerateWorkOrder(value) {
  const response = await Axios.post(`${FemsGraph}/api/femscheduledworkorderheaders`, value);
  return response;
}
async function regenerateBemsWorkOrder(value) {
  const response = await Axios.post(`${BemsGraph}/api/bemscheduledworkorderheaders`, value);
  return response;
}

async function getWorkOrderNo(Facilityid,token) {    
  const response = await Axios.get(`${MasterGraph}/api/GraphDocumentSerialNumber/GetDocumentSerialNumberDetails/${Facilityid}/PWR/${token}?size=3000`);
   return response?.data;
}

const PpmGenerationRepository = {
  getPpmGenerationList,
  getLocationDetails,
  getPPMGenerationFetch,
  getAllAssetsFromAssetRegister,
  regenerateWorkOrder,
  getPpmGenerationListBEMS,
  getPPMGenerationFetchBEMS,
  getBEMSPPMGenerationFetch,
  getWorkOrderNo,
  getBemsWorkOrderDetails,
  getFemsWorkOrderDetails,
  regenerateBemsWorkOrder
};


export default PpmGenerationRepository;
